import React, { useEffect, useState } from "react";
import stech from "../../assets/stech.png";
import "./signup.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MyContextSupply } from "../../Context";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";

const Sign_in = () => {
  const navigate = useNavigate();
  const {
    setAllUseEffectRunCode,
    toggleLoginPassword,
    isLoginPasswordVisible,
  } = MyContextSupply();
  const [logdata, setData] = useState({
    email: "",
    password: "",
  });
  const [isBtnClicked, setIsBtnClicked] = useState(false);

  const { email, password } = logdata;

  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  const adddata = (e) => {
    const { name, value } = e.target;
    setData({ ...logdata, [name]: value });
  };
  const onSubmitHandle = async (event) => {
    event.preventDefault();
    if (!email || !password) {
      toast.warn("Please fill all the inputs", toastStyle);
    } else {
      setIsBtnClicked(true);
      return await axios
        .post("https://stechbackend-9r4c.onrender.com/login", {
          email,
          password,
        })
        .then((res) => {
          if (res.status === 201) {
            toast.success(res.data.message, toastStyle);
            setData({ email: "", password: "" });
            localStorage.setItem("tokens", JSON.stringify(res.data.tokens));
            localStorage.setItem("isAdmin", JSON.stringify(res.data.isAdmin));
            // console.log(res.data.tokens);
            setAllUseEffectRunCode("Success");
            setIsBtnClicked(false);
            setTimeout(() => {
              navigate("/personalinfo");
            }, 1000);
          }
        })
        .catch((err) => {
          const message = err.response.data;
          if (err) {
            toast.warn(message, toastStyle);
          }
          setIsBtnClicked(false);
        });
    }
  };

  return (
    <>
      <section className="section-signin-signup">
        <div className="sign_container">
          <div className="sign_header">
            <img src={stech} alt="" />
          </div>
          <div className="sign_form">
            <form onSubmit={onSubmitHandle}>
              <h1>Sign-In</h1>
              <div className="form_data">
                <label htmlFor="Email">Email</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={adddata}
                  id="email"
                  placeholder="example@gmail.com"
                  className="input-register-signin"
                />
              </div>
              <div className="form_data">
                <label htmlFor="password">Password</label>
                <input
                  type={`${isLoginPasswordVisible ? "text" : "password"}`}
                  name="password"
                  value={password}
                  onChange={adddata}
                  id="password"
                  placeholder="At least 6 characters"
                  autoComplete="off"
                  className="input-register-signin"
                />
                <p onClick={toggleLoginPassword} className="posab-eye-icon">
                  {isLoginPasswordVisible ? (
                    <AiFillEye />
                  ) : (
                    <AiFillEyeInvisible />
                  )}
                </p>
              </div>
              <button
                type="submit"
                disabled={isBtnClicked}
                className={`${
                  isBtnClicked ? "signin_btn checkedBtn " : "signin_btn"
                }`}
              >
                {isBtnClicked ? <FaCheck className="checkIcon" /> : "Login"}
              </button>
            </form>
          </div>
          <div className="create_accountinfo">
            <p>New to S-Technology?</p>
            <button>
              <Link to="/register">Create your S-Tech account</Link>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sign_in;
